export const translations = {
  en: {
    // Navigation
    dashboard: "Dashboard",
    fleet: "Fleet Logistics",
    analytics: "CO2 Analytics",
    compliance: "LKSG Compliance",

    // Titles & Headers
    fleetTitle: "Fleet Operations",
    analyticsTitle: "CO2 Analytics",
    auditTrail: "Live Audit Trail",
    telemetry: "Telemetry Stream",

    // Actions & Buttons
    reset: "Clear Data",
    calculate: "Calculate CO2",
    checkInputs: "Check Inputs",
    exportReport: "Export Official ESG Report",
    exportFiltered: "Export Filtered Report",

    // Form & Table Labels
    productName: "Product Name",
    weight: "Weight (kg)",
    distance: "Distance (km)",
    newEntry: "New Shipment Entry",
    trackingId: "Tracking ID",
    cargo: "Cargo Description",
    calculation: "Calculation",
    certification: "Certification",

    // Stats & Status
    liveCO2: "Live CO2",
    totalDist: "Total Distance",
    fuelLevel: "Fuel Level",
    systemStatus: "System Status",
    active: "Active",
    verified: "Verified",
    moving: "Moving",
    idling: "Idling",
    status: "Status",
    fuel: "Fuel",

    // Analytics Specific
    regionalImpact: "Regional Impact",
    gridEfficiency: "Grid Efficiency",
    cumulativeFootprint: "Cumulative Footprint",
    reduction: "Reduction",
    optimization: "Optimization",
    certifiedLogs: "Certified Emission Logs",

    // Legal & Footer
    legalDisclaimer:
      "This report is generated in accordance with LKSG § 10 (Reporting Obligations). Data encrypted via local session hash.",
    version: "V2.4.0-PRO",
    noShipments: "No shipments recorded yet",
    noMatches: "No matching audit records found",
    searchPlaceholder: "Search ID or Product...",
  },
  de: {
    // Navigation
    dashboard: "Instrumententafel",
    fleet: "Flottenlogistik",
    analytics: "CO2-Analyse",
    compliance: "LKSG-Konformität",

    // Titles & Headers
    fleetTitle: "Flottenbetrieb",
    analyticsTitle: "CO2-Analyse",
    auditTrail: "Live-Audit-Protokoll",
    telemetry: "Telemetrie-Stream",

    // Actions & Buttons
    reset: "Daten löschen",
    calculate: "CO2 berechnen",
    checkInputs: "Eingaben prüfen",
    exportReport: "Offiziellen ESG-Bericht exportieren",
    exportFiltered: "Gefilterten Bericht exportieren",

    // Form & Table Labels
    productName: "Produktname",
    weight: "Gewicht (kg)",
    distance: "Distanz (km)",
    newEntry: "Neuer Sendungseintrag",
    trackingId: "Tracking-ID",
    cargo: "Frachtbeschreibung",
    calculation: "Berechnung",
    certification: "Zertifizierung",

    // Stats & Status
    liveCO2: "Live-CO2",
    totalDist: "Gesamtstrecke",
    fuelLevel: "Kraftstoffstand",
    systemStatus: "Systemstatus",
    active: "Aktiv",
    verified: "Verifiziert",
    moving: "In Bewegung",
    idling: "Leerlauf",
    status: "Status",
    fuel: "Tank",

    // Analytics Specific
    regionalImpact: "Regionale Auswirkungen",
    gridEfficiency: "Netzeffizienz",
    cumulativeFootprint: "Gesamt-Fußabdruck",
    reduction: "Reduktion",
    optimization: "Optimierung",
    certifiedLogs: "Zertifizierte Emissionsprotokolle",

    // Legal & Footer
    legalDisclaimer:
      "Dieser Bericht wurde gemäß LKSG § 10 (Berichtspflichten) erstellt. Datenverschlüsselung via lokalem Session-Hash.",
    version: "V2.4.0-PRO",
    noShipments: "Noch keine Sendungen erfasst",
    noMatches: "Keine passenden Audit-Datensätze gefunden",
    searchPlaceholder: "Suche ID oder Produkt...",
  },
};
